'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
require('react');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');
var Paragraph = require('../../Paragraph-284fa117.js');
var react = require('@emotion/react');
require('../../parseDataAttributes-81c8dbee.js');
require('@babel/runtime/helpers/slicedToArray');
require('lodash/fp/fromPairs');
require('lodash/fp/map');
require('lodash/fp/toPairs');
require('lodash/fp/flow');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject$1, _templateObject2$1, _templateObject3, _templateObject4;
var H1Styled = styled__default["default"](Paragraph.TextContainer)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    letter-spacing: 0.5px;\n    line-height: ", ";\n\n    /* Bottom margin here and below added to compensate line height and prevent scroll bars to appear. */\n    margin: 0 0 6px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.h1.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.h1.lineHeight;
});
var H2Styled = styled__default["default"](Paragraph.TextContainer)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n    margin: 0 0 5px;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.h2.fontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.h2.lineHeight;
});
var H3Styled = styled__default["default"](Paragraph.TextContainer)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n    margin: 0 0 3px;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.h3.fontSize;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.h3.lineHeight;
});
var H4Styled = styled__default["default"](Paragraph.TextContainer)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n    margin: 0 0 3px;\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.h4.fontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.h4.lineHeight;
});

var _excluded$1 = ["variant", "as", "className", "dataAttributes", "innerRef", "children"],
  _excluded2$1 = ["variant", "as", "className", "dataAttributes", "innerRef", "children"],
  _excluded3 = ["variant", "as", "className", "dataAttributes", "innerRef", "children"],
  _excluded4 = ["variant", "as", "className", "dataAttributes", "innerRef", "children"];
var H1 = function H1(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'bold' : _ref$variant,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'h1' : _ref$as,
    className = _ref.className,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes,
    innerRef = _ref.innerRef,
    children = _ref.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref, _excluded$1);
  return react.jsx(H1Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};
var H2 = function H2(_ref2) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'bold' : _ref2$variant,
    _ref2$as = _ref2.as,
    as = _ref2$as === void 0 ? 'h2' : _ref2$as,
    className = _ref2.className,
    _ref2$dataAttributes = _ref2.dataAttributes,
    dataAttributes = _ref2$dataAttributes === void 0 ? {} : _ref2$dataAttributes,
    innerRef = _ref2.innerRef,
    children = _ref2.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref2, _excluded2$1);
  return react.jsx(H2Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};
var H3 = function H3(_ref3) {
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'bold' : _ref3$variant,
    _ref3$as = _ref3.as,
    as = _ref3$as === void 0 ? 'h3' : _ref3$as,
    className = _ref3.className,
    _ref3$dataAttributes = _ref3.dataAttributes,
    dataAttributes = _ref3$dataAttributes === void 0 ? {} : _ref3$dataAttributes,
    innerRef = _ref3.innerRef,
    children = _ref3.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref3, _excluded3);
  return react.jsx(H3Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};
var H4 = function H4(_ref4) {
  var _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? 'bold' : _ref4$variant,
    _ref4$as = _ref4.as,
    as = _ref4$as === void 0 ? 'h4' : _ref4$as,
    className = _ref4.className,
    _ref4$dataAttributes = _ref4.dataAttributes,
    dataAttributes = _ref4$dataAttributes === void 0 ? {} : _ref4$dataAttributes,
    innerRef = _ref4.innerRef,
    children = _ref4.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref4, _excluded4);
  return react.jsx(H4Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};

var _templateObject, _templateObject2;
var Label1Styled = styled__default["default"](Paragraph.TextContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.lb1.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.lb1.lineHeight;
});
var Label2Styled = styled__default["default"](Paragraph.TextContainer)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral__default["default"](["\n    font-size: ", ";\n    line-height: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.lb2.fontSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.lb2.lineHeight;
});

var _excluded = ["variant", "as", "className", "dataAttributes", "innerRef", "children"],
  _excluded2 = ["variant", "as", "className", "dataAttributes", "innerRef", "children"];
var Label1 = function Label1(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'bold' : _ref$variant,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'span' : _ref$as,
    className = _ref.className,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes,
    innerRef = _ref.innerRef,
    children = _ref.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref, _excluded);
  return react.jsx(Label1Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};
var Label2 = function Label2(_ref2) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'bold' : _ref2$variant,
    _ref2$as = _ref2.as,
    as = _ref2$as === void 0 ? 'span' : _ref2$as,
    className = _ref2.className,
    _ref2$dataAttributes = _ref2.dataAttributes,
    dataAttributes = _ref2$dataAttributes === void 0 ? {} : _ref2$dataAttributes,
    innerRef = _ref2.innerRef,
    children = _ref2.children,
    nativeProps = _objectWithoutProperties__default["default"](_ref2, _excluded2);
  return react.jsx(Label2Styled, _extends__default["default"]({}, nativeProps, {
    innerRef: innerRef,
    dataAttributes: dataAttributes,
    variant: variant,
    className: className,
    as: as
  }), children);
};

exports.P1 = Paragraph.P1;
exports.P2 = Paragraph.P2;
exports.P3 = Paragraph.P3;
exports.P4 = Paragraph.P4;
exports.P5 = Paragraph.P5;
exports.TextContainer = Paragraph.TextContainer;
exports.H1 = H1;
exports.H2 = H2;
exports.H3 = H3;
exports.H4 = H4;
exports.Label1 = Label1;
exports.Label2 = Label2;
//# sourceMappingURL=index.js.map
